import * as React from 'react';
import { connect } from 'react-redux';
import { fetchSeller, editSeller } from '../../actions/sellersActions';
import Cleave from 'cleave.js/react';


class DatosContactos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false
        }
    };

    componentWillReceiveProps = prevProps => {
        if (this.didEdit) {
            this.props.fetchSeller(this.props.id);
            this.setState({
                didEdit: false
            })
        }
    }

    myChangeHandler = (event) => {
        this.setState({
            didEdit: true
        })

        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }
    

    render() {
        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="card-body">

                    <h4 className="card-title">Institucional</h4>

                    <div className="row">

                        <div className="form-group col-lg-6">
                            <label>Calle</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={this.props.seller.domicilio} 
                                onChange={this.myChangeHandler} 
                                name="domicilio" 
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Altura</label>
                            <Cleave 
                                className="form-control" 
                                name="numeroDomicilio" 
                                value={this.props.seller.numeroDomicilio}
                                options={{ blocks: [5], numericOnly: true }}
                                onChange={this.myChangeHandler} 
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Códigopostal </label>
                            <Cleave 
                                className="form-control" 
                                name="codigoPostal" 
                                value={this.props.seller.codigoPostal}
                                options={{ blocks: [4],numericOnly: true }}
                                onChange={this.myChangeHandler} 
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Localidad</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={this.props.seller.localidad} 
                                onChange={this.myChangeHandler} 
                                name="localidad" 
                            />
                        </div>

                        <div className="form-group col-lg-6">
                            <label>Provincia</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={this.props.seller.provincia} 
                                onChange={this.myChangeHandler} 
                                name="provincia" 
                            />
                        </div>
                        
                        <div className="form-group col-lg-6">
                            <label>Teléfono</label>
                            <Cleave 
                                className="form-control" 
                                name="telefono" 
                                value={this.props.seller.telefono}
                                options={{ blocks: [10],numericOnly: true }}
                                onChange={this.myChangeHandler} 
                            />
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    seller: JSON.stringify(state.general.generalObject) != "{}" ? state.general.generalObject : state.sellers.seller,
    tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, { fetchSeller, editSeller }) (DatosContactos);